import { useEffect, useState } from "react";

/**
 * Whether the browser thinks it has a network.
 *
 * <p>A second copy of the same twelve lines the application has in `offline/use-online.ts`, and on
 * purpose: this one is used by {@link RequireAuth}, which runs <em>above</em> everything the
 * application provides — there is no provider yet, and a package that every frontend depends on must
 * not start depending on one of them.
 *
 * <p>`navigator.onLine` answers "is there a cable", not "is the server up", which is why the guard
 * that uses this also asks the identity provider directly.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() => (typeof navigator === "undefined" ? true : navigator.onLine));

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);

  return online;
}
